import { format } from "@swiggy-private/js-utils";
import { CTA_TEXTS } from "../constants";
import { ProgramSubTypes } from "@super-ui/interfaces/SwiggyOne";

export const getPrimaryCTA = (hasSignificantCartDifference: boolean, cartSavings: string, planType?: string) => {
    if (hasSignificantCartDifference && planType === ProgramSubTypes.PLUS) {
        return format(CTA_TEXTS.PRIMARY_ONE_V2, cartSavings);
    } else if (hasSignificantCartDifference && planType === ProgramSubTypes.LITE) {
        return format(CTA_TEXTS.PRIMARY_ONE_LITE_V2, cartSavings);
    } else if (planType === ProgramSubTypes.LITE) {
        return CTA_TEXTS.PRIMARY_ONE_LITE_V1;
    }
    return CTA_TEXTS.PRIMARY_ONE_V1;
};

export const getSecondaryCTA = (hasSignificantCartDifference: boolean, planType?: string) => {
    if (hasSignificantCartDifference && planType === ProgramSubTypes.PLUS) {
        return CTA_TEXTS.SECONDARY_ONE_V2;
    } else if (hasSignificantCartDifference && planType === ProgramSubTypes.LITE) {
        return CTA_TEXTS.SECONDARY_ONE_LITE_V2;
    } else if (planType === ProgramSubTypes.LITE) {
        return CTA_TEXTS.SECONDARY_ONE_LITE_V1;
    }
    return CTA_TEXTS.SECONDARY_ONE_V1;
};
